import "./styles.less";

import { Col, Row } from "antd";

import { FullScreen } from "../../FullScreen/web";
import React from "react";
import { useTheme } from "../../../Styles/ThemeHook";
import dynamic from "next/dynamic";

const Modal = dynamic(
	() => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);

export const ModalSimilars = ({
	visible,
	onCancel,
	property_id,
	children,
	mode,
	commonProperty = true,
}) => {
	const { theme } = useTheme();

	return (
		<Modal
			show={visible}
			onClose={onCancel}
			width={"420px"}
			className={"similar-modal"}>
			<FullScreen className="similar-modal-container">
				<Row
					justify={"center"}
					align={"middle"}
					gutter={[0, theme.spacing.mdSpacing]}
					className="similar-modal-content">
					<Col span={24}>{children}</Col>

				</Row>
			</FullScreen>
		</Modal>
	);
};
